import { collectWhenLoaded } from '@finn-no/navigation-timing';

export default {
    callable() {
        collectWhenLoaded('mfinn');
    },
};



// WEBPACK FOOTER //
// ./controllers/clientStats.js